import {INIT_APP} from '~/common/fabric/constants';
import {SET_BLUEPRINT} from './constants';

export const initialState = {
  // biome-ignore lint/style/useNamingConvention: existing error
  blueprint_id: null,
  // biome-ignore lint/style/useNamingConvention: existing error
  blueprint_type: null,
  // biome-ignore lint/style/useNamingConvention: existing error
  show_when: false,
  // biome-ignore lint/style/useNamingConvention: existing error
  show_where: true,
  // biome-ignore lint/style/useNamingConvention: existing error
  background_urls: [],
  // biome-ignore lint/style/useNamingConvention: existing error
  field_schema: [],
  // biome-ignore lint/style/useNamingConvention: existing error
  max_rows: 100,
  // biome-ignore lint/style/useNamingConvention: existing error
  theme_id: '',
  ready: false,
};

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case INIT_APP: {
      const {blueprint = {}} = action.payload;
      return {
        ...state,
        ...blueprint,
        ready: Object.keys(blueprint) > 0,
      };
    }
    case SET_BLUEPRINT: {
      return {
        ...state,
        ...action.payload,
        ready: true,
      };
    }
    default: {
      return state;
    }
  }
};
